import React from 'react';
import Button from '../../common/components/Button';
import styled from '@emotion/styled';
import './index.css';
import StartImg from './img/start.png';
import { ReactComponent as PlannerSvg } from './img/Planner.svg';
import { ReactComponent as CalendarSvg } from './img/Calendar.svg';
import { ReactComponent as MailSvg } from './img/Mail.svg';
import { ReactComponent as MessengerSvg } from './img/Messenger.svg';
import { ReactComponent as SupportSvg } from './img/Support.svg';
import { useNavigate } from 'react-router-dom';
import { ToolElem } from './components/ToolElem';
import { useAuth } from 'common/context/AuthContext';

const HomeSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 80vh;
  gap: 40px;
  flex:1;
  padding: 0 135px;
  padding-bottom:80px;
  @media (max-width: 1280px) {
    padding: 0 80px;
  }
  @media (max-width: 1024px) {
    padding: 0 40px;
    justify-content: flex-start;
    min-height: unset;
    padding-bottom: 80px;
  }
`;

export default function HomePage() {
  const navigate = useNavigate();

  /**
   * Navigates to the specified path.
   * @param path - The path to navigate to.
   * @param replace - Whether to replace the current entry in the history stack.
   */
  const navigateTo = (path: string, replace?: boolean) => {
    navigate(path, { replace: replace || false });
  };

  const { token, companyId } = useAuth();

  if (token && companyId) {
    navigateTo(`/${companyId}`);
  }

  return (
    <HomeSection>
      <div className="home-header">
        <div className="headergov">
          <div className="wrapper headergov__wrapper">
            <span className='logo-text big-logo'>ASTIN</span>
          </div>
        </div>
      </div>
      <div className="start-wrapper">
        <div className="start-text-wrapper">
          <h1 className="start-title">Працюйте ще продуктивніше в єдиному середовищі</h1>
          <p className="start-text">Гнучке інноваційне рішення, яке допомагає людям і організаціям досягати ще більше.</p>
          <div className="start-button-wrapper">
            <Button className='home-button' label='УВІЙТИ' type='submit' onClick={() => { navigateTo('/login');}}></Button>
            <Button className='home-button' label='ЗАРЕЄСТРУВАТИСЯ' primary onClick={() => { navigateTo('/registration');}}></Button>
          </div>
        </div>
        <div className="start-image">
          <img src={StartImg} alt='HomeImg' />
        </div>
      </div>
      <div className="tool-wrapper">
        <div className="tool-title">Інструменти<span className="tool-remove"> для спільної й ефективної роботи на всіх етапах</span></div>
        <div className="tool-elem-wrapper">
          <ToolElem label='Calendar'><CalendarSvg /></ToolElem>
          <ToolElem label='Mail'><MailSvg /></ToolElem>
          <ToolElem label='Messenger'><MessengerSvg /></ToolElem>
          <ToolElem label='Planner'><PlannerSvg /></ToolElem>
          <ToolElem label='Support'><SupportSvg /></ToolElem>
        </div>
      </div>
    </HomeSection>
  );
}

